/*
 * This file is generated by icons/template.js
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { COMMON, CommonProps } from '../constants';
import theme from '../theme';
import sizeStyle, { IconSizeProps } from '../lib/iconSize';

const SvgComponent = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 512 512" {...props}>
    <path
      d="M308.007 203.151c8.25 8.25 8.25 21.625 0 29.876-8.25 8.222-21.625 8.25-29.876 0-25.06-25.09-65.974-25.09-91.062 0L83.025 337.07c-25.088 25.117-25.088 65.946 0 91.063 25.117 25.088 66.002 25.088 91.063 0l52.036-52.036c8.25-8.25 21.597-8.25 29.847 0s8.25 21.625 0 29.875l-52.008 52.036c-20.808 20.752-48.093 31.143-75.406 31.143-27.314 0-54.599-10.39-75.407-31.143-41.533-41.59-41.533-109.224 0-150.785L157.22 203.15c41.561-41.533 109.197-41.533 150.786 0zM458.973 52.199c41.589 41.561 41.589 109.197 0 150.758L354.929 307.028c-20.133 20.133-46.911 31.227-75.407 31.227-28.467 0-55.246-11.094-75.378-31.227-8.25-8.25-8.25-21.625 0-29.875 8.278-8.279 21.653-8.222 29.875 0 24.357 24.385 66.79 24.328 91.035 0l104.043-104.044c25.117-25.116 25.117-65.945 0-91.062-24.244-24.3-66.678-24.329-91.034 0l-54.204 54.204c-8.279 8.25-21.626 8.222-29.848 0-8.25-8.25-8.25-21.626 0-29.876L308.215 52.2c40.294-40.294 110.52-40.237 150.758 0z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

type Props = CommonProps & IconSizeProps;
const IconLink = styled(SvgComponent)<Props>`
  ${sizeStyle}
  ${COMMON}
`;
IconLink.defaultProps = {
  theme,
};
IconLink.propTypes = { ...sizeStyle.propTypes, ...COMMON.propTypes, theme: PropTypes.object };
IconLink.displayName = 'IconLink';
export { IconLink };
